// extracted by mini-css-extract-plugin
module.exports = {"root":"meta-area_root__J8MGY","textWrapper":"meta-area_textWrapper__sBl75","meta":"meta-area_meta__Qx7vm","someItems":"meta-area_someItems__N6_nA"};